import React from 'react';
import { Mail, Linkedin, Phone, Calendar } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-red-500">Get In</span>{' '}
            <span className="text-blue-500">Touch</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            I'm always open to discussing new opportunities, collaborations, or just having a chat about DevOps and cloud technologies.
          </p>
          <div className="w-20 h-1 bg-gradient-to-r from-red-500 to-blue-500 mt-4 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Contact Information</h3>
              <div className="space-y-4">
                <a
                  href={`mailto:${personalInfo.email}`}
                  className="flex items-center gap-4 p-4 bg-red-50 border-2 border-red-200 rounded-xl hover:border-red-400 transition-all duration-300 group"
                >
                  <div className="p-3 bg-red-100 rounded-lg group-hover:bg-red-200 transition-colors">
                    <Mail className="text-red-600" size={24} />
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 font-semibold">Email</div>
                    <div className="text-gray-800 font-medium">{personalInfo.email}</div>
                  </div>
                </a>

                <a
                  href={`tel:${personalInfo.phone}`}
                  className="flex items-center gap-4 p-4 bg-blue-50 border-2 border-blue-200 rounded-xl hover:border-blue-400 transition-all duration-300 group"
                >
                  <div className="p-3 bg-blue-100 rounded-lg group-hover:bg-blue-200 transition-colors">
                    <Phone className="text-blue-600" size={24} />
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 font-semibold">Phone</div>
                    <div className="text-gray-800 font-medium">{personalInfo.phone}</div>
                  </div>
                </a>

                <a
                  href={`https://${personalInfo.linkedin}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-4 p-4 bg-green-50 border-2 border-green-200 rounded-xl hover:border-green-400 transition-all duration-300 group"
                >
                  <div className="p-3 bg-green-100 rounded-lg group-hover:bg-green-200 transition-colors">
                    <Linkedin className="text-green-600" size={24} />
                  </div>
                  <div>
                    <div className="text-sm text-gray-600 font-semibold">LinkedIn</div>
                    <div className="text-gray-800 font-medium">linkedin.com/in/sshprotocol</div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          {/* Calendly */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-gray-800 mb-2">Book a Call</h3>
            <div className="flex items-center gap-2 text-gray-600">
              <Calendar size={18} className="text-blue-500" />
              <span className="text-sm">30-minute chat</span>
            </div>
            <div className="w-full h-[620px] rounded-xl border-2 border-gray-200 overflow-hidden bg-white shadow-sm">
              <iframe
                title="Calendly"
                src="https://calendly.com/mpavan-k-15/30min"
                className="w-full h-full"
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
